<template>
  <div
    class="product-gallery"
    :class="{ 'product-gallery--controls': items && items.length && items.length > 1 }"
  >
    <ProductParamSlider
      v-if="items && items.length"
      v-slot="{ item }"
      :items="items"
      :slider-options="sliderOptions"
      ref="params"
      @prev="prev"
      @next="next"
    >
      <label
        class="product-gallery__slider-img"
        :class="{ 'product-gallery__slider-img--active': active === item.id }"
      >
        <input type="radio" v-show="false" :value="item.id" v-model="active" />
        <ImgComponent :head_img="item" width="400" height="400" />
      </label>
    </ProductParamSlider>
    <div @click="showImagesModal" class="product-gallery__image">
      <template v-if="isImagesModal">
        <button @click="prev" class="product-gallery__btn product-gallery__btn-prev btn">
          <IconComponent name="arrow-left-1" />
        </button>
        <button @click="next" class="product-gallery__btn product-gallery__btn-next btn">
          <IconComponent name="arrow-right-1" />
        </button>
      </template>
      <ImgZoomComponent :head_img="activeItem" width="900" height="900">
        <div class="product-gallery__image-ratio">
          <div class="ratio-container">
            <ImgComponent :head_img="activeItem" width="900" height="900" :default-alt="defaultAlt" contain />
          </div>
        </div>
      </ImgZoomComponent>
    </div>
  </div>
</template>

<script>
import ProductParamSlider from "components/product/ProductParamSlider.vue";
import ImgZoomComponent from "components/ImgZoomComponent.vue";
import IconComponent from "components/IconComponent.vue";
import ImagesGalleryModal from "components/modals/components/ImagesGalleryModal.vue";

export default {
  name: "ProductGalleryComponent",
  props: {
    defaultAlt: String,
    items: {
      type: Array,
      default: () => [],
    },
    head_img: Object,
    firstActiveItem: Object,
    isModal: Boolean, // модалка с предварительным просмотром товара
    isImagesModal: Boolean, // модалка для просмотра фотографий товара
  },
  data() {
    return {
      active: null,
      sliderOptions: {
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 10,
        pagination: false,
        clickable: false,
        breakpoints: {
          721: {
            direction: "vertical",
            slidesPerView: 4,
          },
        },
      },
    };
  },
  computed: {
    activeItem() {
      return this.items.find((i) => i.id === this.active) || this.head_img;
    },
  },
  created() {
    if (this.items && this.items.length) {
      this.active = this.items[0].id;
    }
  },
  mounted() {
    if (this.isImagesModal) {
      document.addEventListener("keydown", this.handleKeyDown);
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", () => {});
  },
  watch: {
    items() {
      if (this.items && this.items.length) {
        this.active = this.items[0].id;
      }
    },
  },
  methods: {
    handleKeyDown(e) {
      if ([37, 38].includes(e.keyCode)) {
        this.prev();
      }
      if ([39, 40].includes(e.keyCode)) {
        this.next();
      }
    },
    next() {
      let currentIndex = this.items.findIndex((item) => item.id === this.active);
      // если есть текущий элемент и он не последний
      if (![-1, this.items.length - 1].includes(currentIndex) && this.$refs.params) {
        this.active = this.items[currentIndex + 1]?.id;
        this.$refs.params.slideNext();
      }
    },
    prev() {
      let currentIndex = this.items.findIndex((item) => item.id === this.active);
      // если есть текущий элемент и он не первый
      if (![-1, 0].includes(currentIndex) && this.$refs.params) {
        this.active = this.items[currentIndex - 1]?.id;
        this.$refs.params.slidePrev();
      }
    },
    showImagesModal() {
      if (!this.isModal && !this.isImagesModal) {
        this.$store.state._modals.push({
          component: ImagesGalleryModal,
          options: {
            images: this.items,
            head_img: this.head_img,
            defaultAlt: this.defaultAlt,
            activeItem: this.activeItem,
          },
          fullHeight: true,
        });
      }
    },
  },
  components: { IconComponent, ImgZoomComponent, ProductParamSlider },
};
</script>

<style lang="stylus">
@import "~@/styles/mixins/ratio.styl"
.product-gallery {
  display flex
  align-items flex-start
  gap 20px
  +below(720px) {
    gap 0
    flex-direction column-reverse
  }

  .param-slider {
    width 100px
    height 530px
    flex-shrink: 0;
    +below(1150px) {
      height 480px
    }
    +below(720px) {
      width 100%
      height 120px
    }
  }

  &__slider-img {
    display flex
    align-items center;
    justify-content center
    border: 1px solid var(--main-color-75);
    border-radius: var(--main_radius)
    width 100px
    height 100px
    overflow hidden
    cursor pointer
    padding 5px
    transition border-color var(--transition)
    +below(480px) {
      width 80px
      height 80px
    }

    &:not(&--active):hover {
      border-color var(--main-color)
    }

    &--active {
      border: 2px solid var(--main-color-75);
    }

    img {
      max-width 100%
      max-height 100%
      object-fit contain
      object-position center
    }
  }

  &__image {
    height auto
    width 100%
    max-width 100%
    display flex
    justify-content center
    align-items center
    overflow hidden
    border: 1px solid var(--main-color-75);
    border-radius: 30px;

    &-ratio {
      ratio(1, 1, contain)

      img {
        padding 20px
      }
    }
  }
}
</style>
